import { Controller } from '@hotwired/stimulus';
import { callApiWithoutBody } from '../common/AjaxUtil';

export default class extends Controller {
  static targets = ['modal', 'adMessages'];
  static values = { 'adMessengerId': Number };

  #adMessageTemplate = `
      <span>{{index}}.</span>
      <span class="ml-1">{{name}}</span>
      <span class="ml-1">{{email}}</span>
      <span class="ml-1">{{phoneNumber}}</span>`;

  #progressSuccessTemplate = `<span class="text-sm ml-1"><span class="xi-check text-green-700 font-bold">성공</span>`;
  #progressFailTemplate = ` <span class="text-sm ml-1"><span class="xi-minus-circle-o text-red-600 font-bold">실패({{reason}})</span>`;
  #progressReservedTemplate = ` <span class="text-sm ml-1"><span class="xi-time-o font-bold">예약</span>`;
  #progressSendingTemplate = ` <span class="text-sm ml-1"><span class="xi-time-o font-bold">전송중</span>`;
  #progressCanceledTemplate = ` <span class="text-sm ml-1"><span class="xi-alarm-off font-bold">취소</span>`;

  openModal() {
    this.fetchMessages(this.adMessengerIdValue);
    document.body.classList.add('overflow-hidden');
    this.modalTarget.classList.remove('hidden');
  }

  closeModal() {
    document.body.classList.remove('overflow-hidden');
    this.modalTarget.classList.add('hidden');
  }

  fetchMessages(adMessengerId) {
    callApiWithoutBody(`/api/ad-messengers/${adMessengerId}/ad-messages`, 'GET')
    .then(response => {
      const content = response.content;
      let adMessages = '';
      for (let i = 0; i < content.length; i++) {
        let adMessage = `<p class="text-sm">` + this.#adMessageTemplate;
        const reason = content[i].reason;
        const progress = content[i].progress;
        adMessage = adMessage.replace('{{index}}', i + 1);
        adMessage = adMessage.replace('{{name}}', content[i].name);
        adMessage = adMessage.replace('{{phoneNumber}}', content[i].phoneNumber);
        adMessage = adMessage.replace('{{email}}', content[i].email);
        if (progress === 'SUCCESS') {
          adMessage += this.#progressSuccessTemplate;
        } else if (progress === 'FAILED') {
          adMessage += this.#progressFailTemplate.replace('{{reason}}', reason);
        } else if (progress === 'RESERVED') {
          adMessage += this.#progressReservedTemplate;
        } else if (progress === 'SENDING') {
          adMessage += this.#progressSendingTemplate;
        } else if (progress === 'CANCELED') {
          adMessage += this.#progressCanceledTemplate;
        }
        adMessages += adMessage + `</p>`;
      }
      this.adMessagesTarget.innerHTML = '';
      this.adMessagesTarget.insertAdjacentHTML('beforeend', adMessages);
    })
    .catch(err => {
      console.error(err);
      this.closeModal();
      window.$sendAlert(err.msg);
    });
  }


}
